// Interest tracking for disabled preference rows. Wired into Amplitude
// (initialized in main.tsx) plus a dev-mode console breadcrumb.

import * as amplitude from '@amplitude/unified';

export function trackInterest(featureId: string): void {
  if (import.meta.env.DEV) console.info('[interest]', featureId);
  amplitude.track('feature_requested', { feature_id: featureId });
}
